/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
export const environment = {
    headerClass: '',
    app_id:'tszpzvu5',
    loginImage: 'assets/demo/images/login/geo-login-xom.jpg',
    appVersion: require('../../package.json').version,
    baseUrl: 'https://perform.geoserves.com',
    reportServerUrl:'https://perform.geoserves.com',
    verificationServiceUrl:'https://perform.geoserves.com',
    backgroundServerUrl : 'https://perform.geoserves.com',
    cpbackgroundServiceUrl :'https://perform.geoserves.com',
    sensorengine: 'https://perform.geoserves.com',
    name: 'GeoPerform QA',
    production: true,
    // Usage analytics (Amplitude). Deliberately NOT derived from `production`
    // above: `production` controls Angular's prod mode, and UAT now runs with
    // it enabled so production-only defects surface before release. Tying
    // analytics to the same flag would send UAT/QA traffic into the production
    // Amplitude account. Only the real production deployment reports.
    enableAmplitude: true,
    apiUrl: "https://perform.geoserves.com",
    // Per-service overrides for running a backend locally. Empty means "use apiUrl", which is
    // the correct value in every deployed environment - there, all services sit behind one host.
    userApiUrl: "",
    masterApiUrl: "",
    digitalTwinApiUrl: "",
    voyageApiUrl: "",
    authServerUrl: "https://perform.geoserves.com",
    authServerLoginApi: "https://perform.geoserves.com/api/auth/login",
    authServerLoginWithSsoApi: "https://perform.geoserves.com/api/auth/login-with-sso",
    authServerLoginWithGeoOneSsoApi: "https://perform.geoserves.com/api/auth/login-with-geo-one-sso",
    authServerRefreshApi: "https://perform.geoserves.com/api/auth/refresh",
    authServerLogoutApi: "https://perform.geoserves.com/api/auth/logout",
    SSOclientId: "826d2118-79c1-4140-afbc-b141104b84b5",
    SSOAutority: "a0bdf996-65bc-49f7-9b9a-687d34df8c65",
    graphMeEndpoint: "https://graph.microsoft.com",
    microsoftLoginUrl: "https://login.microsoftonline.com",
    post_logout_redirect_uri: "https://perform.geoserves.com/auth/login",
    // ETS Specific
    etsMaster: "https://perform.geoserves.com/api/master",
    etsVoyage: "https://perform.geoserves.com/api/voyage",
    storageApiUrl: "https://perform.geoserves.com/api/voyage",
    etsRepoURL: "https://perform.geoserves.com/api/ets",
    voyageoptimisation:"https://vo.geoserves.com/login",
    etsBaseUrl: "https://perform.geoserves.com/api/ets",
    pulseUrl: "https://pulse.geoserves.com"
  };